import { createSlice } from '@reduxjs/toolkit';

export const namespace = 'settingList';

const initialState = {
  loading: true,
  error: null,
  data: null
};

export const slice = createSlice({
  name: namespace,
  initialState,
  reducers: {
    getList: (state) => ({
      ...state,
      // loading: true,
    }),
    getListSuccess: (state, action) => ({
      ...state,
      error: null,
      data: action.payload,
      loading: false,
    }),
    getListError: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload,
      data: null,
    })
  }
});

// Action creators are generated for each case reducer function
export const { getList, getListSuccess, getListError } = slice.actions;
// Selector
export const settingListSelector = (state) => state[namespace];
// Reducer
export const { reducer } = slice;

export { rootSagas as saga } from './saga';
